import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';

import { ShDragDataDirective } from '../../../elements/directives/drag-data/drag-data.module';
import { NavigationLinkDirective } from '../../directives/navigation-link/navigation-link-directive.module';
import { NavigationLink } from '../navigation-item/entities/navigation-link.entity';

@Component({
    standalone: true,
    selector: 'sh-list-row-title',
    templateUrl: './list-row-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, NavigationLinkDirective, ShDragDataDirective]
})
export class ShListRowTitleComponent {
    @Input() title!: string;
    @Input() info?: string;
    @Input() wrap = false;
    @Input() navigationLink?: NavigationLink;
    @Input() dragString?: string;
    @Input() minWidthInRem?: number;
}
